import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import initializeGA from '@/utils/initializeGA';
import { Dispatch } from '@/utils/store';

const InitialLoader: FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch<Dispatch>();
  const [loaded, setIsLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      const user = await dispatch.auth.fetchCurrentUser();

      if (user) {
        initializeGA(user.email);
      }

      setIsLoaded(true);
    })();
  }, [dispatch]);

  return loaded ? <>{children}</> : null;
};

export default InitialLoader;
